import { render, staticRenderFns } from "./UpZipConfirm.vue?vue&type=template&id=57eac8d7&scoped=true"
import script from "./UpZipConfirm.vue?vue&type=script&lang=js"
export * from "./UpZipConfirm.vue?vue&type=script&lang=js"
import style0 from "./UpZipConfirm.vue?vue&type=style&index=0&id=57eac8d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eac8d7",
  null
  
)

export default component.exports